/* eslint-disable camelcase */
/* eslint-disable */

import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { DateTime } from 'luxon';
import { IconButton, TablePagination } from '@material-ui/core';
import { Header, Container } from '../../../styles/shared/styles';
import { excelExport } from '../../../service/excel.service';
import { ExportButton } from './styles';
import CompTable from '../../../components/CompTable';
import { maskCpf, maskDateTime } from '../../../utils/masks';
import api from '../../../service/api';
import CssStyles from '../css.styles';


const SubscriptionWithoutFinishedLead = () => {
    const [data, setData] = useState([]);
    const [getShowData, setShowData] = useState(false);
    const [filters, setFilters] = useState({
      per_page: 10,
      filterPage: 0,
    });
    
    const MontarUrl = (page) => {
      const filtros = Object.keys(filters).map((x) => (filters[x] != undefined ? `${x}=${filters[x]}` : ''));
      let url = '';
      filtros.forEach((x) => {
        if (url != '') {
          url += '&';
        }
        url += x;
      });

      if (page) 
        url+=`&page=${page}`;

      return url;
    };
    
    const GetSubscriptionData = async (page) => {
        setShowData(false);
        const response = await api.get(`/maistodos/subscriptionWithoutFinishedLead?${MontarUrl(page)}`);
        setData(response.data.data);
        setShowData(true);
    }

    const handleChangePage = (event, newPage) => {
        setFilters({ ...filters, filterPage: newPage });
        GetSubscriptionData(newPage+1);
    };

    const handleChangeRowsPerPage = (event) => {
      setFilters({ ...filters, filterPage: 0, per_page: parseInt(event.target.value, 10) });
      GetSubscriptionData(0);
    };

    const maskSold = (sold) => {
      return sold == 1 ? 'Vendido' : 'Não vendido';
    }

    

  const colums = [
      { titulo: 'Lead', variavel: 'id' },
      { titulo: 'Cliente', variavel: 'name' },
      { titulo: 'CPF', variavel: 'cpf', tratamento: (cpf) => maskCpf(cpf)},
      { titulo: 'Vendedor', variavel: 'vendedor' },
      { titulo: 'Data do Lead', variavel: 'created_at', tratamento: (created_at) => maskDateTime(created_at) },
      { titulo: 'Vendido', variavel: 'sold', tratamento: (sold) => maskSold(sold) },
      { titulo: 'Data de Finalização', variavel: 'end_lead_date', tratamento: (end_lead_date) => maskDateTime(end_lead_date) },
      { titulo: 'Valor', variavel: 'valorAssinatura' },
      { titulo: 'Id Maistodos', variavel: 'identificadorMaistodos' },
  ];


  return (
    <>
      <motion.div initial={CssStyles.motionDivInitial} animate={CssStyles.motionDivAnimate} exit={CssStyles.motionDivExit}>
        <Container>
          <Header>
            <h2>Clientes com assinatura ativa e Lead não finalizado</h2>
          </Header>

          <div style={{display: 'inline-block', float: 'left', marginTop: '20px'}}>
            <p>
            <ExportButton
              style={{  marginTop: '5px' }}
              type="button"
              onClick={() => GetSubscriptionData(0)}>
              Consultar
            </ExportButton>
            </p>
          </div>

          {getShowData && 
            (
              <>
                <TablePagination
                  component="div"
                  count={data ? data.total : 0}
                  page={filters.filterPage}
                  onPageChange={handleChangePage}
                  rowsPerPage={filters.per_page}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
                <CompTable data={data?.data} colums={colums} />
              </>
            )
          }    

          <div style={{display: 'inline-block', float: 'right', marginTop: '20px'}}>
            <p>
            <ExportButton
              style={{  marginTop: '5px' }}
              type="button"
              onClick={() => {
                excelExport(
                  `/maistodos/subscriptionWithoutFinishedLeadExport`,
                  `relatorio_de_Assinaturas_sem_Lead_Finalizado${DateTime.now().toFormat('dd_LL_yyyy')}`
                );
              }}>
              Exportar
            </ExportButton>
            </p>
            <br/>
          </div>      
        </Container>
      </motion.div>
    </>
  );    
}

export default SubscriptionWithoutFinishedLead;